import { isPlatformServer } from '@angular/common';
import { inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import type { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

import type { IHttpErrorHandlerService } from './entities/types';
import { RESPONSE } from '../../express.tokens';

@Injectable({ providedIn: 'root' })
export class HttpErrorHandlerService implements IHttpErrorHandlerService {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly injector = inject(Injector);

    private readonly onError$$ = new BehaviorSubject<Error>(null);

    public get onError$(): Observable<Error> {
        return this.onError$$.asObservable();
    }

    public emitError(error: Error): void {
        this.onError$$.next(error);
    }

    public resetError(): void {
        this.onError$$.next(null);
    }

    public setHttpStatus(status = 404): void {
        if (isPlatformServer(this.platformId)) {
            const response = this.injector.get(RESPONSE);
            response.statusCode = status;
        }
    }
}
